import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    SelectFilterModel,
} from '@ui/shared/util-filter';
import { FoundingCategoryOrderingEnum, FoundingMapService } from '@ui/shared/util-api';
import type { FoundingMapFilterKey } from '../../types/founding-map-filters';

@Injectable({ providedIn: 'root' })
export class SectorSelectFilterConfigService extends FilterConfigService<FoundingMapFilterKey, FoundingMapService> {

    constructor() {
        super(
            new SelectFilterModel('sector', 'Branche', []),
            inject(FoundingMapService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllFoundingCategories({
            order: [FoundingCategoryOrderingEnum.Name],
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: dto.name,
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
